<template>
    <div class="content if-profile">
        
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import Vuex from 'vuex';
  import axios from 'axios';
  
  export default {
    name: 'company-profile-auxpage',
    data() {
      return {
        returnedId: 0,
        pollActive: true,
        loading: true,
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        filtered_company_profile_list: [],
      };
    },
    async mounted(){
        setTimeout(async () => {
            do{
                // The poll must die with the component: without the pollActive check this
                // loop kept running after navigating away, and since $route is a reactive
                // global it then fired company-check with the NEW route's (missing) id --
                // surfacing a profile_id_not_set error modal on unrelated pages like
                // /prospect-search.
                if (!this.pollActive || !this.$route.params.id) { break; }
                // CompanyProfileLayout's created() awaits the full /user/profile/company
                // fetch before this page can render at all, so if the store already holds
                // THIS profile's data there is nothing left to wait for. The company-check
                // cache probe below can never confirm readiness for a staging-routed
                // profile (report-staging skips the API_data cache write on purpose), so
                // without this short-circuit a freshly created profile sat on this
                // intentionally blank waiting page forever.
                const profileInfo = this.$store.getters.profileInfo;
                if (profileInfo && profileInfo.profile_id == this.$route.params.id) {
                    this.returnedId = 1;
                    this.$router.push({ path: `/companies/${this.$route.params.id}/profile` });
                    break;
                }
                await this.checkCompanyProfile();
                // The loop had no delay at all, hammering /user/profile/company-check as
                // fast as round-trips allowed (same bug as the NewProfile/NewMarketProfile
                // queue polls). Poll every 5s instead.
                if (this.returnedId == 0) { await new Promise((r) => setTimeout(r, 5000)); }
            }
            while(this.returnedId == 0 && this.pollActive)
        }, 5000);
    },
    beforeDestroy() {
        this.pollActive = false;
    },
    methods: {
        async checkCompanyProfile(){
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            await axios
                .post(
                process.env.VUE_APP_API_BASE_URL + '/user/profile/company-check',
                {},
                {
                    params: {
                        session_id: currentSession,
                        profile_id: this.$route.params.id,
                    },
                }
                )
                .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    this.$store.commit('SET_ERROR_BIT', true);
                    this.$store.commit(
                    'SET_ERROR_INFO',
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/profile/company-check" <br>`
                    );
                    throw new Error(
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode
                    );
                }
                 this.returnedId = res.data.data;

                 if(this.returnedId ==1)
                    this.$router.push({ path: `/companies/${this.$route.params.id}/profile` });
                 
                });
        },
        numberWithPoints(x) {
        if (typeof x === 'number') {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        } else if(x === null){
          return x;
        }else
        {
          return x.replace(/,/g, '.');
        }
      },
      downloadCSVData() {
        let csv = '';
        this.getCsvData.forEach((row) => {
          csv += row.join(',');
          csv += '\n';
        });
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'Company Profile.csv';
        anchor.click();
      },
    },
  
    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
      ifInfo() {
        return this.$store.getters.profileInfo;
      },
      socials() {
        let socials = [];
        let details = this.ifInfo.fine_details.socials;
  
        if (details.facebook)
          socials.push({
            name: 'Facebook',
            url: details.facebook,
            icon: 'fab fa-facebook',
          });
        if (details.foursquare)
          socials.push({
            name: 'FourSquare',
            url: details.foursquare,
            icon: 'fab fa-foursquare',
          });
        if (details.instagram)
          socials.push({
            name: 'Instagram',
            url: details.instagram,
            icon: 'fab fa-instagram',
          });
        if (details.linked_in)
          socials.push({
            name: 'LinkedIn',
            url: details.linked_in,
            icon: 'fab fa-linkedin',
          });
        if (details.pinterest)
          socials.push({
            name: 'Pinterest',
            url: details.pinterest,
            icon: 'fab fa-pinterest',
          });
        if (details.tumblr)
          socials.push({
            name: 'Tumblr',
            url: details.tumblr,
            icon: 'fab fa-tumblr',
          });
        if (details.twitter)
          socials.push({
            name: 'Twitter',
            url: details.twitter,
            icon: 'fab fa-twitter',
          });
        if (details.yelp)
          socials.push({ name: 'Yelp', url: details.yelp, icon: 'fab fa-yelp' });
        if (details.youtube)
          socials.push({
            name: 'YouTube',
            url: details.youtube,
            icon: 'fab fa-youtube',
          });
  
        return socials;
      },
  
      companyLogo() {
        let companyLogo = '';
        if (this.ifInfo && this.ifInfo.fine_details) {
          companyLogo = this.ifInfo.fine_details.logo;
        }
        return companyLogo;
      },
      contacts() {
        let contacts = [];
        if (this.ifInfo && this.ifInfo.fine_details) {
          contacts = this.ifInfo.fine_details.contacts;
        }
        return contacts;
      },
      operatingHours() {
        return this.ifInfo.fine_details.hours
          ? this.ifInfo.fine_details.hours[0]
          : {};
      },
      industries() {
        return this.ifInfo.fine_details.industry;
      },
      profileInfo() {
        return this.$store.getters.profileInfo;
      },
      releaseDate() {
        return this.$store.getters.releaseDate;
      },
      location() {
        return [
          {
            CONAME: this.profileInfo.companyTitle,
            lat: this.profileInfo.latlon.lat,
            lng: this.profileInfo.latlon.lon,
          },
        ];
      },
      mapCenter() {
        return this.profileInfo
          ? { lat: this.profileInfo.latlon.lat, lon: this.profileInfo.latlon.lon }
          : null;
      },
      getFormattedData() {
        let a = {};
  
        a.company = this.profileInfo.companyTitle;
        a.original_name = '';
        a.infogroup = this.profileInfo.locnum;
        a.unique_id = '';
        a.street = this.profileInfo.street ? this.profileInfo.street : '';
        a.city = this.profileInfo.city ? this.profileInfo.city : '';
        a.state = this.profileInfo.state ? this.profileInfo.state : '';
        a.zip = this.profileInfo.zip ? this.profileInfo.zip : '';
        a.industry_code = this.profileInfo.naics;
        a.industry = this.profileInfo.industry;
  
        let b = this.profileInfo.businessOwner
          ? this.profileInfo.businessOwner.split(',')[0]
          : '';
        a.contact_first = b.split(' ')[0];
        a.contact_last = b.split(' ')[1];
        a.phone = this.profileInfo.businessPhone
          ? this.profileInfo.businessPhone
          : '';
        a.url = this.profileInfo.businessURL ? this.profileInfo.businessURL : '';
        let g = this.profileInfo.release_id.replace('_', '-01-20');
        const monthNames = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
  
        a.operation_details =
          monthNames[new Date(g).getMonth()] + ' ' + new Date(g).getFullYear();
        a.location_annual_sales = this.profileInfo.bizop['Location Sales'][0];
        a.location_employment = this.profileInfo.bizop['Employment'][0];
        a.corporation_annual_sales = this.profileInfo.bizop['Corporate Sales'][0];
        a.corporation_employment = this.profileInfo.bizop[
          'Corporate Employment'
        ][0];
  
        a.market_insights_date =
          monthNames[new Date(g).getMonth()] + ' ' + new Date(g).getFullYear();
        a.market_industry_code = this.profileInfo.IMRnaics;
        a.market_industry = this.profileInfo.IMRindustry;
        a.market_area = this.profileInfo['MR']['area'];
  
        a.industry_operations = this.profileInfo['MR']['main'][
          'Industry Operations'
        ];
        a.location_sales_rank = this.profileInfo['MR']['main'][
          'Business Sales Rank'
        ];
        a.industry_market_sales_volume = this.profileInfo['MR']['main'][
          'Annual Market Sales Volume'
        ];
        a.average_site_sales = this.profileInfo['MR']['main'][
          'Average Site Sales'
        ];
        a.average_small_business_sales = this.profileInfo['MR']['main'][
          'Average Small Business Sales'
        ];
  
        a.industry_market_sales_per_person = this.profileInfo['MR'][
          'penetration'
        ]['Market Sales per Person'];
        a.us_industry_sales_per_person = this.profileInfo['MR']['penetration'][
          'US Sales per Person'
        ];
        a.opportunity_index_person = this.profileInfo['MR']['penetration'][
          'Opportunity Index Person'
        ];
        a.industry_market_sales_per_household = this.profileInfo['MR'][
          'penetration'
        ]['Market Sales per Household'];
        a.us_industry_sales_per_household = this.profileInfo['MR']['penetration'][
          'US Sales per Household'
        ];
        a.opportunity_index_household = this.profileInfo['MR']['penetration'][
          'Opportunity Index Household'
        ];
  
        a.market_area_population = this.profileInfo['MR']['income']['Population'];
        a.market_area_households = this.profileInfo['MR']['income']['Households'];
        a.per_capita_income = this.profileInfo['MR']['income'][
          'Per Capita Income'
        ];
        a.mediab_hh__income = this.profileInfo['MR']['income'][
          'Median HH Income'
        ];
        a.business_values_insights_date =
          monthNames[new Date(g).getMonth()] + ' ' + new Date(g).getFullYear();
  
        a.sales_approach_quartile1 = this.profileInfo.multiples.data[
          'Quartile 1'
        ]['sales'];
        a.sales_approach_median = this.profileInfo.multiples.data['Median'][
          'sales'
        ];
        a.sales_approach_quartile3 = this.profileInfo.multiples.data[
          'Quartile 3'
        ]['sales'];
        a.earnings_approach_quartile1 = this.profileInfo.multiples.data[
          'Quartile 1'
        ]['earnings'];
        a.earnings_approach_median = this.profileInfo.multiples.data['Median'][
          'earnings'
        ];
        a.earnings_approach_quartile3 = this.profileInfo.multiples.data[
          'Quartile 3'
        ]['earnings'];
  
        a.if_industry_code = this.profileInfo.naics;
        a.if_industry_name = this.profileInfo.industry;
        a.if_industry_sales_class = this.profileInfo.IF['sales-class'];
        a.financial_insights_date = this.profileInfo.IF['period'];
  
        a.gross_margin_percentage = this.profileInfo.IF.spend[
          'Gross Margin'
        ].percentage;
        a.office_owner_compensation_percentage = this.profileInfo.IF.spend[
          'Officer-Owner-Compensation'
        ].percentage;
        a.depreciation_percentage = this.profileInfo.IF.spend[
          'Depreciation'
        ].percentage;
        a.operating_expense_percentage = this.profileInfo.IF.spend[
          'Operating Expenses'
        ].percentage;
        a.operating_income_percentage = this.profileInfo.IF.spend[
          'Operating Income'
        ].percentage;
        a.after_tax_net_profit_percentage = this.profileInfo.IF.spend[
          'After Tax Net Profit'
        ].percentage;
        a.owner_earnings_percentage = this.profileInfo.IF.spend[
          'Owner Earnings'
        ].percentage;
        a.account_receivable_percentage = this.profileInfo.IF.spend[
          'Accounts Receivable: Total Assets'
        ].percentage;
        a.account_payable_percentage = this.profileInfo.IF.spend[
          'Accounts Payable: TLNW'
        ].percentage;
        a.net_worth_assets_percentage = this.profileInfo.IF.spend[
          'Net Worth: Assets'
        ].percentage;
  
        a.gross_margin_dollar = this.profileInfo.IF.spend['Gross Margin'].dollar;
        a.office_owner_compensation_dollar = this.profileInfo.IF.spend[
          'Officer-Owner-Compensation'
        ].dollar;
        a.depreciation_dollar = this.profileInfo.IF.spend['Depreciation'].dollar;
        a.operating_expense_dollar = this.profileInfo.IF.spend[
          'Operating Expenses'
        ].dollar;
        a.operating_income_dollar = this.profileInfo.IF.spend[
          'Operating Income'
        ].dollar;
        a.after_tax_net_profit_dollar = this.profileInfo.IF.spend[
          'After Tax Net Profit'
        ].dollar;
        a.owner_earnings_dollar = this.profileInfo.IF.spend[
          'Owner Earnings'
        ].dollar;
        a.account_receivable_dollar = this.profileInfo.IF.spend[
          'Accounts Receivable: Total Assets'
        ].dollar;
        a.account_payable_dollar = this.profileInfo.IF.spend[
          'Accounts Payable: TLNW'
        ].dollar;
        a.net_worth_assets_dollar = this.profileInfo.IF.spend[
          'Net Worth: Assets'
        ].dollar;
  
        a.account_payable_revenue = this.profileInfo.IF.benchmarks[
          'Accounts Payable: Revenue'
        ];
        a.current_ratio = this.profileInfo.IF.benchmarks['Current Ratio'];
        a.days_payable = this.profileInfo.IF.benchmarks['Days Payable'];
        a.net_working_capital_revenue = this.profileInfo.IF.benchmarks[
          'Net Working Capital Revenue'
        ];
        a.days_receivable = this.profileInfo.IF.benchmarks['Days Receivable'];
        a.interest_coverage = this.profileInfo.IF.benchmarks['Interest Coverage'];
        a.current_liabilites = this.profileInfo.IF.benchmarks[
          'Current Liabilities: NW'
        ];
        a.loans_notes = this.profileInfo.IF.benchmarks[
          'Loans‐Notes Payable: Net Worth'
        ];
        a.modified_z = this.profileInfo.IF.benchmarks['Modified Z Score'];
        a.total_liabilities = this.profileInfo.IF.benchmarks[
          'Total Liabilties: Net Worth'
        ];
  
        Object.values(a).forEach((element, index) => {
          let b = '';
          if (element && element.includes(',')) {
            b = element.replace(/,/g, '.');
          } else {
            b = element;
          }
          this.filtered_company_profile_list.push(b);
        });
        return this.filtered_company_profile_list;
      },
      getCsvData() {
        let csvData = [
          [
            'Company',
            'Original Name',
            'Infogroup ID',
            'Unique ID',
            'Street',
            'City',
            'State',
            'Zip',
            'Industry Code',
            'Industry',
            'Contact First',
            'Contact Last',
            'Phone',
            'URL',
            'Operation Detail Release',
            'Location Annual Sales',
            'Location Employment',
            'Corporate Annual Sales',
            'Corporate Employment',
            'Market Insights Date',
            'Market Industry Code',
            'Market Industry',
            'Market Area',
            'Industry Operations',
            'Location Sales Rank',
            'Industry Market Sales Volume',
            'Average Site Sales',
            'Average Small Business Sales',
            'Industry Market Sales per Person',
            'US Industry Sales per Person',
            'Opportunity Index',
            'Industry Market Sales per Household',
            'US Industry Sales per Household',
            'Opportunity Index',
            'Market Area Population',
            'Market Area Households',
            'Per Capital Income',
            'Median Household Income',
            'Business Value Insights Date',
            'Sales Approach Quartile1',
            'Sales Approach Median',
            'Sales Approach Quartile3',
            'Earnings Approach Quartile1',
            'Earnings Approach Median',
            'Earnings Approach Quartile3',
            'IF Industry code',
            'IF Industry name',
            'IF Sales class',
            'Financial Insights Date',
            'Gross Margin %',
            'Officer-Owner Compensation %',
            'Depreciation %',
            'Operating Expense %',
            'Operating Income %',
            'After Tax Net Profit %',
            'Owner Earnings %',
            'Accounts Receivable/Total Assets %',
            'Accounts Payable/TLNW %',
            'Net Worth/Assets %',
            'Gross Margin $',
            'Officer-Owner Compensation $',
            'Depreciation $',
            'Operating Expense $',
            'Operating Income $',
            'After Tax Net Profit $',
            'Owner Earnings $',
            'Accounts Receivable/Total Assets $',
            'Accounts Payable/TLNW $',
            'Net Worth/Assets $',
            'Accounts Payable/Revenue',
            'Current Ratio',
            'Days Payable',
            'Net Working Capital/Revenue',
            'Days Receivable',
            'Interest Coverage',
            'Current Liabilities/Net Worth',
            'Loans Notes Payable/Net Worth',
            'Modified Z Score',
            'Total Liabilties/Net Worth',
          ],
        ];
  
        csvData.push(this.getFormattedData);
        return csvData;
      },
      setLoading() {
        return !this.profileInfo;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .introduction-body {
    display: flex;
    align-items: flex-start;
  }
  
  .company-list-title {
    margin: 0 !important;
  }
  
  .mt-1 {
    margin-top: 15px !important;
    text-align-last: left !important;
  }
  
  .introduction-title {
    display: flex;
    flex-direction: column;
    justify-content: end;
  }
  
  .if-profile-body {
    .companis-list-tabl {
      .favorite-list-item {
        .list-item-head {
          align-items: center;
        }
      }
    }
  
    .compani-list {
      iframe {
        height: 280px;
      }
    }
  }
  
  .map-box-title {
    padding: 0 24px;
  }
  
  .subtitle {
    font-size: 1.1rem;
  }
  
  .company-logo {
    text-align: right;
    float: right;
    width: auto !important;
    height: 48px !important;
  }
  
  .company_map #google-map {
    height: 600px !important;
  }
  
  .type-profile .md-card-profile .md-card-header, .type-profile .marketprof-competitors .sub_table .md-table table tr th.md-table-head, .type-profile .demographics .companis-list-tabl li .md-collapse .md-collapse-label, .type-profile .if-profile .if_card .md-card-profile .md-card-header,
  .sub_table .md-table table tr th.md-table-head,
  .extra_info h3 .md-icon {
    color: #003666 !important;
  }
  
  </style>
  